<template> 
  <button
    v-if="processStatus == 'init'"
    id="template_launch_start_process_btn"
    class="w-full bg-secondary-900 p-3 text-white text-sm font-semibold text-center rounded-md btn-shadow primarySettings btn-focus focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-900 focus:ring-offset-2"
    @click="startProcess()"
  >
    {{ monetize == true ? $t('buy_now') : $t('launch_demo') }}
  </button>
    
  <div
    v-if="processStatus == 'in_process'"
    class="flex md:justify-between justify-center flex-wrap lg:flex-nowrap w-full gap-4"
  >
    <!-- <div class="btn-width">
      <button
        class="bg-white border w-full text-bl p-3 text-grayCust-800   text-sm font-semibold text-center rounded-md btn-shadow focus:outline-0 btn-focus focus-visible:outline-0 focus:ring-2 focus:ring-secondary-900 focus:ring-offset-2"
        @click="back()"
      >
        {{ $t('back') }}
      </button>
    </div> -->

    <CButton
      :btn-title="$t('back')"
      btn-type="gray-outline-btn"
      size="btn-md"
      class="w-full"
      @click="back()"
    />

    <CButton  
      v-if="!monetize"
      id="template_launch_proceed_btn"
      :btn-title="$t('proceed')"
      btn-type="secondary"
      size="btn-md"
      class="w-full primarySettings"
      :disabled="(processStatus == 'in_process' && purchaseStatus == 'init' ? true : !(form.email)) || (collectName && !form.name)"
      @click="proceed()"
    />

    <CButton  
      v-else
      id="template_launch_purchase_btn"
      :btn-title="$t('purchase_template')"
      btn-type="secondary"
      :image-path="processStatus == 'in_process' && purchaseStatus == 'init' ? '/images/loading-buffering.gif' : '' "
      size="btn-md"
      class="w-full"
      :disabled="processStatus == 'in_process' && purchaseStatus == 'init' ? true : !(form.name && form.email)"
      @click="purchaseSite()"
    />
    <!-- :is-icon-component="processStatus == 'in_process' && purchaseStatus == 'init' ? true : false"
      icon-com-name="ButtonLoading" -->

    <!-- <div class="btn-width">
      <button
        v-if="!monetize"
        class=" sm2:ml-3 w-full bg-secondary-900 p-3 button-margin text-white text-sm font-semibold text-center rounded-md btn-shadow disabled:opacity-60 btn-focus primarySettings focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-900 focus:ring-offset-2"
        @click="proceed()"
      >
        {{ $t('proceed') }}
      </button>
      <button
        v-else
        :disabled="!(form.name && form.email)"
        class=" sm2:ml-3 w-full bg-secondary-900 p-3 sm2:mt-0 mt-4 button-margin text-white text-sm font-semibold text-center rounded-md btn-shadow btn-focus disabled:opacity-60 primarySettings focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-900 focus:ring-offset-2"
        @click="purchaseSite()"
      >
        {{ $t('purchase_template') }}
      </button>
    </div> -->
  </div>
  <!-- v-if="processStatus == 'in_process' && purchaseStatus == 'init'" -->
  <div
    v-if="false"
    class="w-full"
  >
    <button class="w-full bg-secondary-800 py-2.5 flex justify-center text-white text-base font-semibold shadow-sm rounded-md hover:bg-secondary-800 primarySettings btn-focus focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-900 focus:ring-offset-2"> 
      <span class="animate-spin mr-2">
        <loading-icon />
      </span>
      {{ $t('loading') }}
    </button>
  </div>


  <div
    v-if="!monetize && processStatus == 'complete' && !autoLaunch"
    class="w-full flex items-center justify-center"
  >
    <button
      v-if="isClone && !isCloning"
      class="w-full flex text-primary-900 border border-primary-900 items-center justify-center cursor-pointer bg-white font-semibold magic-login site-created-shadow mr-4 px-4 py-2.5 rounded-md focus:outline-0 focus-visible:outline-0 btn-focus focus:ring-2 focus:ring-primary-900 focus:ring-offset-2 max-w-half"
      @click="cloneSite()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="-ml-1 mr-3 h-5 w-5 text-primary-900"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      ><path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
      /></svg> {{ $t('clone_site') }}
    </button>
    <button
      class=" font-semibold w-full flex text-white items-center justify-center  cursor-pointer bg-secondary-800  button-margin magic-login site-created-shadow button-margin  sm2:ml-4 mt-4 sm2:mt-0 px-4 py-2.5 rounded-md primarySettings btn-focus focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-800 focus:ring-offset-2 max-w-half"
      @click="magicLogin()"
    >
      <svg
        class="mr-2 w-5"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      ><path
        data-v-3add84db=""
        d="M6.52217 3.11111L5.54217 4.2L7.36217 6.22222H0.222168V7.77778H7.36217L5.54217 9.8L6.52217 10.8889L10.0222 7L6.52217 3.11111ZM12.8222 12.4444H7.22217V14H12.8222C13.5922 14 14.2222 13.3 14.2222 12.4444V1.55556C14.2222 0.7 13.5922 0 12.8222 0H7.22217V1.55556H12.8222V12.4444Z"
        fill="currentColor"
      /></svg>
      {{ $t('magic_login') }}
    </button>
  </div>
  <div class="flex flex-wrap gap-4 items-center">
    <div
      v-if="monetize && processStatus == 'complete' && isUserExist == 1"
      class="btn-width"
    >
      <a
        class="w-full flex text-primary-900 border border-primary-900 items-center justify-center cursor-pointer bg-white font-semibold magic-login site-created-shadow mr-4 px-4 py-2.5 rounded-md focus:outline-0 focus-visible:outline-0 btn-focus focus:ring-2 focus:ring-primary-900 focus:ring-offset-2"
        href="/"
      >{{ $t('view_dashboard') }}</a>
    </div>
    <div
      v-if="processStatus == 'complete' && !autoLaunch && monetize"
    >
      <button
        class=" font-semibold w-full flex text-white items-center justify-center  cursor-pointer bg-secondary-800  button-margin magic-login site-created-shadow button-margin  sm2:ml-4 mt-4 sm2:mt-0 px-4 py-2.5 rounded-md primarySettings btn-focus focus:outline-0 focus-visible:outline-0 focus:ring-2 focus:ring-secondary-800 focus:ring-offset-2"
        @click="magicLogin()"
      >
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          class="mr-2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1667 11.334L16.5 8.00065M16.5 8.00065L13.1667 4.66732M16.5 8.00065L4.83333 8.00065M9.83333 11.334V12.1673C9.83333 13.548 8.71405 14.6673 7.33333 14.6673H4C2.61929 14.6673 1.5 13.548 1.5 12.1673V3.83398C1.5 2.45327 2.61929 1.33398 4 1.33398H7.33333C8.71405 1.33398 9.83333 2.45327 9.83333 3.83398V4.66732"
            stroke="currentColor"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg> 
        {{ $t('admin_login') }}
      </button>
    </div>
  </div>
</template>

<script>
import LoadingIcon from '@/Common/LoadingIcon.vue';
import CButton from '@/components/New/Blocks/Buttons/CommonButton.vue';


export default {
    name: "Footer",
    components:{
      LoadingIcon,
      CButton
    },
    props:{
        isCloning: {
            default: false,
            type: Boolean,
        },
        isClone: {
            default: false,
            type: Boolean,
        },
        price: {
            default: 0,
            type: Number,
        },
        monetize: {
            default: false,
            type: Boolean,
        },
        interval: {
            default: '',
            type: String,
        },
        processStatus: {
            default: 'init',
            type: String,
            required: true
        },
        purchaseStatus: {
            default: '',
            type: String,
        },
        displaySettings: {
            type: Object,
            default: {
                primaryColor: '#15B881',
                accentColor: '#ffffff',
            },
        },
        form: {
            type: Object,
            default: {
                name: "",
                email: "",
            }
        },
        autoLaunch: {
            type: Boolean
        },
        isUserExist: {
            type: Number,
            default: 0,
        },
        collectName: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        startProcess() {
            this.$emit('startProcess');
        },
        back() {
            this.$emit('back');
        },
        purchaseSite(){
            this.$emit('purchaseSite');
        },
        proceed() {
            this.$emit('proceed');
        },
        magicLogin() {
            this.$emit('magicLogin');
        },
        cloneSite() {
            this.$emit('cloneSite');
        }
   }
}
</script>
<style scoped>
.primarySettings {
    background-color: v-bind('displaySettings.primaryColor');
    color: v-bind('displaySettings.accentColor');
}
.btn-width{
    width:50%;
}
.btn-content{
    width: 100%;
}
.btn-focus:focus-visible{
    outline: 0 !important;
}
.max-w-half{
    max-width: 50%;
}
@media screen and (max-width:576px) {
    .btn-width{
        width: 100% !important;
    }
    .btn-content{
        width: 100%;
    }
    .button-margin{
        margin-left: 0 !important;
        margin-top: 16px !important;
    }
    
}
</style>
